import { render, staticRenderFns } from "./SupplierStockPriceMarkupComponent.vue?vue&type=template&id=20cd4167&"
import script from "./SupplierStockPriceMarkupComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockPriceMarkupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports